import * as React from 'react'
import { SVGProps } from 'react'

const SANDUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16.001' cy='16.0001' r='16' fill='white' />
    <path
      d='M10.5361 7.53087L8.80273 9.26421V16.1333L10.5361 17.8667H17.4052V21.3333H14.0027V19.6H8.80273V23.0667L10.5361 24.8H20.8719L22.6052 23.0667V16.1333L20.8719 14.4H14.0027V10.9333H17.4694V12.6667H22.6694V9.20001L20.9361 7.46667H10.5361V7.53087Z'
      fill='url(#paint0_linear_4956_76243)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_4956_76243'
        x1='6.90161'
        y1='15.9461'
        x2='17.7225'
        y2='25.7144'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#00ADEF' />
        <stop offset='1' stopColor='#0084FF' />
      </linearGradient>
    </defs>
  </svg>
)

export default SANDUSD
